import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 24px;
  background-color: white;

  @media (max-width: 768px) {
    padding: 16px 12px;
    gap: 12px;
  }
`;

export const PlansList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`;

export const disableButtonCSS = css`
  outline: unset !important;
  border-width: 0;

  &:disabled {
    background-color: #acacac !important;
    border: 1px #acacac !important;
    outline: 1px #acacac !important;
    color: #686a79 !important;
  }
`;

export const modalContainerCss = css`
  padding: 34px 24px;
  width: 500px;
  max-width: 500px;

  @media (max-width: 768px) {
    width: calc(100vw - 24px);
    max-width: none;
    padding: 20px 12px;
  }
`;

export const Button = styled.button`
  cursor: pointer;
  background: #ffffff;

  width: 140px;
  height: 36px;
  padding: 8px 16px 8px 16px;
  gap: 10px;
  border-radius: 8px;
  border: 1px;

  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;

  &:hover {
    background: #fff8d9;
  }

  &:active {
    background: #d9b244;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
